import { API_PATH } from '../constants/defaults'
import { BaseAPI } from './BaseAPI'
import { Service, ServiceDelivery } from '../types/interfaces'

export class ServiceAPI extends BaseAPI {
  public async getServices(programId: string): Promise<Service[]> {
    return this.api.get(`${API_PATH.SERVICE}/${programId}`).then((response) => response.data)
  }


  public async postDelivery(shiftId: string, data: ServiceDelivery): Promise<ServiceDelivery> {
    return this.api.post(`${API_PATH.SERVICE}/delivery/${shiftId}`, data).then((response) => response.data)
  }

  public async updateDelivery(deliveryId: string, data: Partial<ServiceDelivery>, shiftId: string): Promise<ServiceDelivery> {
    return this.api.patch(`${API_PATH.SERVICE}/delivery/${deliveryId}`, { ...data, shiftId: shiftId }).then((response) => response.data)
  }

  public async deleteDelivery(deliveryId: string, shiftId: string): Promise<string> {
    return this.api.delete(`${API_PATH.SERVICE}/delivery/${deliveryId}`, { data: { shiftId: shiftId } }).then((response) => response.data)
  }
  }

